import { PASSWORD_RULES } from "@/lib/password";
import { CheckCircle, Circle } from "@phosphor-icons/react";

const LEVELS = [
  { label: "Very weak", bar: "bg-destructive", text: "text-destructive" },
  { label: "Weak", bar: "bg-destructive", text: "text-destructive" },
  { label: "Fair", bar: "bg-amber-500", text: "text-amber-600 dark:text-amber-400" },
  { label: "Good", bar: "bg-yellow-500", text: "text-yellow-600 dark:text-yellow-400" },
  { label: "Strong", bar: "bg-emerald-500", text: "text-emerald-600 dark:text-emerald-400" },
  { label: "Very strong", bar: "bg-emerald-600", text: "text-emerald-600 dark:text-emerald-400" },
];

export function PasswordRequirements({ value = "", className = "" }) {
  const passed = PASSWORD_RULES.filter((r) => r.test(value)).length;
  const total = PASSWORD_RULES.length;
  const level = LEVELS[passed];
  const pct = (passed / total) * 100;

  return (
    <div className={className} data-testid="password-requirements">
      {value.length > 0 && (
        <div className="mb-2" data-testid="password-strength-meter">
          <div className="h-1.5 w-full rounded-full bg-muted overflow-hidden">
            <div
              className={`h-full rounded-full transition-all duration-300 ease-out ${level.bar}`}
              style={{ width: `${pct}%` }}
              data-testid="password-strength-bar"
            />
          </div>
          <p className={`mt-1 text-xs font-medium ${level.text}`} data-testid="password-strength-label">
            {level.label}
          </p>
        </div>
      )}
      <ul className="space-y-1">
        {PASSWORD_RULES.map((r) => {
          const ok = r.test(value);
          return (
            <li key={r.label} className={`flex items-center gap-2 text-xs ${ok ? "text-emerald-600 dark:text-emerald-400" : "text-muted-foreground"}`}>
              {ok ? <CheckCircle size={14} weight="fill" /> : <Circle size={14} />}
              {r.label}
            </li>
          );
        })}
      </ul>
    </div>
  );
}
